import React from 'react';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/fp/isEmpty';
import map from 'lodash/fp/map';
import { Row } from 'components/common/grid';
import ControlledSelect from 'components/common/form-controlled/controlled-select';
import { SelectOption } from 'components/common/input-components/select';
import Button from 'components/common/button';
import AddNewTokenModal from 'components/organizations/credentials/tokens/add-new-token-modal';
import { useModal } from 'hooks/modal.hooks';
import { useGetTokens } from 'stores/rq/vcs-auth-tokens';
import { TokenTypes, type Token } from 'types/api.types';
import type { VcsConnectionsForm } from './access-card/use-connection-modal-access-card-form.hook';

export const VcsConnectionModalFormAccessToken: React.FC<VcsConnectionsForm> = ({ form }) => {
  const { data: tokens = {} } = useGetTokens(TokenTypes.GIT);
  const { isModalOpen, showModal, hideModal } = useModal();

  return (
    <Row align="middle" justify="start">
      <ControlledSelect
        form={form}
        name="tokenId"
        mandatory
        width={100}
        label={{ id: 'organization.settings.agents.vcs-connections-modal.authentication.AccessToken.token' }}
        placeholder={
          <FormattedMessage id="organization.settings.agents.vcs-connections-modal.authentication.AccessToken.token.placeholder" />
        }
        data-e2e="vcs-connection-modal-token-select"
        customActions={
          <Button onClick={showModal} type="primary" size="small">
            <FormattedMessage id="settings.tokens.add.new.title" />
          </Button>
        }>
        {isEmpty(tokens) ? (
          <SelectOption disabled value="">
            <FormattedMessage id="templates.add.new.field.token.empty" />
          </SelectOption>
        ) : (
          map(
            (token: Token) => (
              <SelectOption key={token.id} value={token.id!}>
                {token.name}
              </SelectOption>
            ),
            tokens
          )
        )}
      </ControlledSelect>
      <AddNewTokenModal
        open={isModalOpen}
        hideModal={hideModal}
        onTokenCreated={id => {
          form.setValue('tokenId', id, { shouldValidate: true });
        }}
        tokens={tokens}
      />
    </Row>
  );
};
